<template>
  <div :class="$options.name">
    <layout-default v-if="!token"></layout-default>
    <in-app v-else></in-app>
  </div>
</template>

<script>
  import {mapGetters} from "vuex"
  import LayoutDefault from "./layout/LayoutDefault.vue"
  import InApp from "./layout/InApp.vue"

  export default {
    name: "App",
    components: {
      LayoutDefault,
      InApp
    },
    computed: {
      ...mapGetters(["token"])
    }
  }
</script>

<style lang="scss">
  @import "../scss/settings/color";
  @import "../scss/components/_text.scss";
  @import "../scss/components/_input.scss";
  @import "../scss/components/_form.scss";
  @import "../scss/components/_linktext.scss";
  @import "../scss/components/_checkbox.scss";
  @import "../scss/components/_table.scss";
  @import "../scss/utility.scss";
  @import "../scss/components/_snackbar.scss";
  html {
    font-family: "Roboto";
  }

  * {
    box-sizing: border-box;
  }
</style>
